import { OctAutocomplete } from "@oceantech/oceantech-ui";
import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { AppContext } from "../../../appContext/AppContext";
import FilterSidebar from "../../../component/filter-sidebar/FilterSidebar";
import LazyLoadTable from "../../../component/lazy-load-table/LazyLoadTable";
import {
  CODE,
  DEFAULT_PAGE_INDEX,
  LEVEL,
  LOAI_PHONG,
  RESPONSE_MESSAGE,
} from "../../../utils/Constant";
import {
  formatDateToYYYYMMDD,
  formatTrangThaiBenhNhan,
} from "../../../utils/FormatUtils";
import { getListKhoaPhong } from "../../../utils/ServicesUtils";
import { WfSummaryStatusRes } from "../../../workflows/models/WfWorkflows";
import { convertListDichVuXetNgiem } from "../../common";
import { STATUS_SUMMARY } from "../../const/constants";
import { PhanHeXetNghiemContext } from "../../context/PhanHeXetNghiemContext";
import {
  getBenhNhanInfo,
  getListPatientXN,
  getListStatusXN,
  getPhieuXetNghemInfo,
} from "../../service/tiepNhan";
import ContextMenu from "../../../component/ContextMenuV3";
import { IContextMenu } from "../../../phan-he-tiep-nhan-thanh-toan/models/ModelTabDSDangKy";
import withBarcodeScan from "../../../../hoc/withBarcodeScan";
import { useSpeechStream } from "../../../utils/SpeechStream";
import PatientRowData from "../../../component/patient-row-data";
import { localStorageItem } from "../../../utils/LocalStorage";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import DepartmentFilter from "src/app/modules/phan-he-kham-benh/components/department-filter/DepartmentFilter";

const DsBenhNhan = (props: any) => {  
  const { setPhieuXetNghiemInfo, setBenhNhanInfo, selectedBenhNhan, setSelectedBenhNhan } = useContext(
    PhanHeXetNghiemContext
  );
  const { setIsLoading } = useContext(AppContext);
  const { startSpeechStream } = useSpeechStream();
  const [summaryStatus, setSummaryStatus] = useState<WfSummaryStatusRes[]>([]);
  // const [selectedBenhNhan, setSelectedBenhNhan] = useState<any>();
  const [searchObject, setSearchObject] = useState<any>(null);
  const [listFilter, setListFilter] = useState<any>(null);
  const [contextMenu, setContextMenu] = useState<null | {
		x: number;
		y: number;
	  }>(null);
  const [rowSeclectedByContextMenu, setRowSeclectedByContextMenu] = useState<any>();
  const searchParamsRef = useRef<any>({});
  const departmentRef = useRef(null);
  const speakerConfig = localStorageItem.get(KEY_LOCALSTORAGE.SPEAKER_CONFIG);

  useEffect(() => {
    listFilter &&
      setSearchObject({
        ...listFilter,
        order: null
      });
  }, [listFilter]);
  
  useEffect(() => {  
    if (props?.barcode) {
      searchBarcode(props.barcode);
    }
  }, [props?.barcode]);

  const getDanhSachTraiThaiXN = async (searchData?: any) => {
    setIsLoading(true);
    let searchObject = {
      pageIndex: DEFAULT_PAGE_INDEX,
      pageSize: 9999999,
      ...searchData,
    };
    try {
      const { data } = await getListStatusXN(searchObject);
      if (CODE.SUCCESS === data?.code) {
        const result = (data?.data || []).filter(
			    (status: any) => status.statusCode !== STATUS_SUMMARY.CHUA_LAY_MAU
		    );
        setSummaryStatus(result);
      } else {
        toast.warning(RESPONSE_MESSAGE.ERROR);
      }
    } catch {
      toast.warning(RESPONSE_MESSAGE.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectedBenhNhan = async (benhNhan: any, callbackFn?: () => void) => {
    try {
      setIsLoading(true);
      let { data: dataBN } = await getBenhNhanInfo(benhNhan?.id);
      let { data: dataXN } = await getPhieuXetNghemInfo(benhNhan?.id);
      if (CODE.SUCCESS === dataBN?.code && CODE.SUCCESS === dataXN?.code) {
        let thongTinPhieu = dataXN?.data;        
        const dsXetNghiem = convertListDichVuXetNgiem(thongTinPhieu.ordersList);
        setSelectedBenhNhan(benhNhan);
        setPhieuXetNghiemInfo({
          thongTinPhieu,
          dsXetNghiem,
        });
        setBenhNhanInfo({
          ...dataBN?.data,
          isPerform: false,
          testGroupId: benhNhan?.id,
        });
        callbackFn?.();
      } else {
        toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      }
    } catch (error) {
      console.error(error);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: "TT",
      field: "",
      headerStyle: {
        maxWidth: "30px",
      },
      render: (rowData: any, index: number) => formatTrangThaiBenhNhan(rowData?.color),
    },
    {
      name: "STTLM",
      field: "samplingOrdinalNumber",
      cellStyle: {
        textAlign: "center",
      },
      render: (rowData: any, index: number) => <span className="text-system">{rowData?.samplingOrdinalNumber || ""}</span>
    },
    {
      name: "Barcode",
      field: "barcode",
      headerStyle: {
        minWidth: "80px",
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (rowData: any, index: number) => <span className="text-system">{rowData?.barcode || ""}</span>
    },
    {
      name: "Tên bệnh nhân",
      field: "",
      headerStyle: {
        minWidth: "150px",
      },
      render: (rowData: any) => {
        return (
          <PatientRowData 
            data={rowData}
          />
        );
      },
    },
    {
      name: "Mã BP",
      field: "code",
      headerStyle: {
        minWidth: "100px",
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (rowData: any, index: number) => <span className="text-system">{rowData?.code || ""}</span>
    },
  ];

  const doSearch = (props: any) => {
    const searchObject = {
      keyword: props?.keyword,
      barcode: props?.additionalFieldSearch || null,
      sortBy: props.formal?.value || listFilter?.sortBy || null,
      descending: props.order?.value === "DERCEASE" || !props.order,
      order: props.order,
      fromDate:
        formatDateToYYYYMMDD(props.period?.fromDate) || listFilter?.fromDate,
      toDate: formatDateToYYYYMMDD(props.period?.toDate) || listFilter?.toDate,
      filterBy: props?.filterBy || listFilter?.filterBy || null,
      filterValue: props?.filterValue || listFilter?.filterValue || null,
      fulfillDeptCode: departmentRef.current || null,
    };
    searchParamsRef.current = searchObject;
    setListFilter({
      ...searchObject,
    });
  };

  useEffect(() => {
    searchObject && getDanhSachTraiThaiXN(searchObject);
  }, [props.statusChangedEvent, searchObject]);

  const LIST_FORMAL = [
    {
      id: 1,
      value: "indicationTime",
      name: "Ngày y lệnh",
    },
    {
      id: 2,
      value: "specimenCollectionStartTime",
      name: "Ngày lấy mẫu",
    },
    {
      id: 3,
      value: "testingStartTime",
      name: "Ngày thực hiện",
    },
    {
      id: 4,
      value: "resultReportingTime",
      name: "Ngày trả kết quả",
    },
  ];

  const searchBarcode = (barcode: string) => {
			getListPatientXN({
        ...searchParamsRef.current,
				barcode,
			})
      .then(({ data }) => {
				const list = data.data?.content ?? [];

				if (!list.length) {
					toast.warn(`Không tìm thấy phiếu xét nghiệm với mã barcode: ${barcode}`);
					return;
				}

				const patientSelected = list[0];
        
				handleSelectedBenhNhan(patientSelected, () => {
          toast.success(`Lấy thông tin phiếu xét nghiệm với barcode: ${barcode} thành công`);
        });
			})
      .catch((error) => {
        console.error(error);
        toast.warn(RESPONSE_MESSAGE.ERROR);
      });
	};

  const CODE_MENU = {
		GOI_BN: "goiBn",
	  };
	
	const dropListChiDinhDichVu: IContextMenu[] = [
		{
		  title: "Xét nghiệm",
		},
		{
		  icon: <i className="bi bi-volume-up-fill text-pri"></i>,
		  code: CODE_MENU.GOI_BN,
		  name: "Gọi bệnh nhân",
		},
	  ];
  const handleContextMenu = (e: any, row: any) => {
      setRowSeclectedByContextMenu(row);
      setContextMenu({ x: e.clientX, y: e.clientY });
  };
  const handleGoiBN = (data: any) => {
    if (!speakerConfig?.speaker) {
      toast.warning("Không tìm thấy cấu hình phát loa");
      return;
    }
		let stt = data?.samplingOrdinalNumber;
		let name = data?.patientName;
		let diaDiem = data?.fulfillDeptName;
		if (stt && diaDiem) {
      let { spkApi, spkPath1, spkPath2, spkPath3 } = speakerConfig.speaker;
			let content = `${spkPath1}, ${name} , ${spkPath3} ${diaDiem}`;
      startSpeechStream({
        url: spkApi,
        content,
      });
		} else {
			toast.warning("Bệnh nhân không đủ thông tin phòng thực hiện");
		}
	};
	const handleClickOptionContextMenu = (value: any) => {
		const menuActions = {
			[CODE_MENU.GOI_BN]: () => handleGoiBN(rowSeclectedByContextMenu),
		};
		menuActions[value?.code]?.();
		setContextMenu(null);
	};

  return (
    <>
      <FilterSidebar
        title="Danh sách"
        formalList={LIST_FORMAL}
        onSearch={doSearch}
        listMenuItem={[]}
        handleSelectOption={() => {}}
        additionalTextSearch={{
					name: 'barcode',
					placeholder: 'Barcode'
				}}
        roomTypeHasPendingScreen={LOAI_PHONG.PHONG_XET_NGHIEM}
      />
      <div className="spaces h-calc-vh-170 d-flex flex-column pt-10">
        <div className="spaces h-calc-vh-333">
          <LazyLoadTable
            columns={columns}
            axiosReq={getListPatientXN}
            searchData={searchObject}
            urlData="data.data.content"
            className="spaces h-calc-vh-333"
            onRowClick={row => handleSelectedBenhNhan(row)}
            dependencies={[props.statusChangedEvent]}
            rowSeclected={selectedBenhNhan}
            handleContextMenu={handleContextMenu}
          />
          {contextMenu && (
						<ContextMenu
							handleClickOptionContextMenu={handleClickOptionContextMenu}
							handleCloseMenu={() => setContextMenu(null)}
							data={dropListChiDinhDichVu}
							target={contextMenu}
						/>
						)}
        </div>
        <Row className="d-flex spaces w-100">
          <Col xs={12} className="spaces ps-5 pb-3 pr-0">
            <DepartmentFilter 
              value={departmentRef.current}
              onChange={(option) => {
                departmentRef.current = option?.code;
                doSearch({
                  ...listFilter,
                  fulfillDeptCode: option?.code,
                });
              }}
              params={{ type: LOAI_PHONG.PHONG_XET_NGHIEM }}
              moduleType="test"
            />
          </Col>
        </Row>
        <Row className="count-status-xet-nghiem spaces w-100 gap-10 px-5 justify-content-center mx-auto">
          {summaryStatus.map((item, index) => (
            <div
              key={index}
              className="d-flex status text-white rounded spaces px-8 py-4 w-100 justify-content-center cursor-pointer"
              style={{ backgroundColor: item.color }}
              onClick={() => {
                doSearch({
                  ...listFilter,
                  filterBy: "currStatusCode",
                  filterValue: item?.statusCode,
                });
              }}
            >
              <span className="body-normal-1 spaces">{`${item.statusName}: ${item.summary}`}</span>
            </div>
          ))}
        </Row>
      </div>
    </>
  );
};

export default withBarcodeScan(DsBenhNhan);
